<template>
  <WizardQuestion
    :title="
      getComponentUiText(
        'app-component-wizards-setup-wizard-miscellaneous-page-title-1',
      )
    "
    :description="
      getComponentUiText(
        'app-component-wizards-setup-wizard-miscellaneous-page-sub-title-1',
      )
    "
  >
    <div
      v-if="
        statusInPage.statusPage === statusPage.Error &&
        statusInPage.errorMessage
      "
      class="tw-bg-[#FEE5E2] tw-px-[12px] tw-py-[8px] tw-flex tw-items-center tw-rounded-[6px] tw-gap-[10px]"
    >
      <WarningIcon color="#F7553C" />
      <p
        class="tw-text-[#F7553C] tw-text-[11px] tw-font-[500] tw-leading-[130%] tw-text-center tw-mb-[0px]"
      >
        {{
          (getComponentUiText("app-component-wizards-setup-error-tooltip"),
          false,
          {
            errorMessage: statusInPage.errorMessage
              ? ensurePeriod(statusInPage.errorMessage)
              : "",
          })
        }}
      </p>
    </div>

    <WizardRadioQuestion
      :title="
        getComponentUiText(
          'app-menu-submenu-home-setup-wizard-modal-misc-questions-pii-title-1',
        )
      "
      :required="true"
      :answer="isMiscPii"
      :disabled="false"
      :is-api-error="
        statusInPageClone.dataError.length > 0 &&
        statusInPageClone.dataError[0]['miscPII'] === true
      "
      @on-update="checkYesNoPii"
    />
    <WizardRadioQuestion
      :title="
        getComponentUiText(
          'app-menu-submenu-home-setup-wizard-modal-misc-questions-phi-title-1',
        )
      "
      :required="true"
      :answer="isMiscPhi"
      :disabled="false"
      :is-api-error="
        statusInPageClone.dataError.length > 0 &&
        statusInPageClone.dataError[0]['miscPHI'] === true
      "
      @on-update="checkYesNoPhi"
    />
  </WizardQuestion>
</template>

<script setup lang="ts">
import { getComponentUiText } from "@/utils/utilities";
import WizardQuestion from "./wizardQuestion.vue";
import WizardRadioQuestion from "./wizardRadioQuestion.vue";
import store from "@/store";
import { computed } from "vue";
import { statusPage } from "@/utils/constants";
import WarningIcon from "../svgs/warningIcon.vue";

const props = defineProps({
  statusInPage: {
    type: Object,
    default: () => ({
      statusPage: statusPage.NotChange,
      dataError: [],
    }),
  },
});

const statusInPageClone = computed(() => {
  return props.statusInPage;
});

const checkYesNoPii = (value) => {
  if (statusInPageClone.value?.dataError?.[0]?.miscPII)
    delete statusInPageClone.value.dataError[0]["miscPII"];

  const checkedValue = value ? true : false;
  store.commit("SetupWizard/SET_STATE_MISCPII", checkedValue);
};

const checkYesNoPhi = (value) => {
  if (statusInPageClone.value?.dataError?.[0]?.miscPHI)
    delete statusInPageClone.value.dataError[0]["miscPHI"];

  const checkedValue = value ? true : false;
  store.commit("SetupWizard/SET_STATE_MISCPHI", checkedValue);
};

const isMiscPii = computed(() => {
  const setupWizard = store.state.SetupWizard;
  if (setupWizard.questions[currentOrg.value.id]?.misc[0]?.values) {
    const isMiscPiiSelected = setupWizard.questions[
      currentOrg.value.id
    ].misc[0].values.some((item) => item.name && item.endDate == null);
    return isMiscPiiSelected ? 1 : 0;
  } else {
    return 0;
  }
});

const isMiscPhi = computed(() => {
  const setupWizard = store.state.SetupWizard;
  if (setupWizard.questions[currentOrg.value.id]?.misc[1]?.values) {
    const isMiscPhiSelected = setupWizard.questions[
      currentOrg.value.id
    ].misc[1].values.some((item) => item.name && item.endDate == null);
    return isMiscPhiSelected ? 1 : 0;
  } else {
    return 0;
  }
});

const emits = defineEmits(["check:answer"]);
const currentOrg = computed(() => store.state.Org.currentOrg);
</script>
